// geoHelper.ts
export async function getUserLocation() {
    try {
      // 1. Get raw coords from browser
      const coords = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 5000
        });
      });
  
      const { latitude, longitude } = coords.coords;
  
      // 2. Convert coords → city + country using Open-Meteo reverse geocoding (free)
      const resp = await fetch(
        `https://geocoding-api.open-meteo.com/v1/reverse?latitude=${latitude}&longitude=${longitude}`
      );
      const data = await resp.json();
  
      if (data && data.results && data.results.length > 0) {
        const loc = data.results[0];
        return {
          city: loc.city || loc.name || "",
          country: loc.country || ""
        };
      }
    } catch (err) {
      console.warn("Geolocation failed, falling back to IP lookup");
    }
  
    // 3. IP fallback (also free)
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const data = await resp.json();
  
      return {
        city: data.city || "",
        country: data.country_name || ""
      };
    } catch (e) {
      console.error("IP lookup failed", e);
    }
  
    // 4. Fallback if everything fails
    return {
      city: "",
      country: ""
    };
  }
  